export default __webpack_public_path__ + "static/media/CNo.56-5.d8c29906.jpg";